import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MenuItemBookModel } from '../views/models/menu-item-book.model';
import { MenuItemBookDetailModel } from '../views/models/menu-item-book-detail.model';
import { MenuItemModel } from '../views/models/menu-item.model';
import { MenuTitleDescriptionModel } from '../views/models/menu-title-description.model';
import { MenuItemCatalogGroupModel } from '../views/models/menu-item-catalog-group.model';
import { MenuItemCatalogModel } from '../views/models/menu-item-catalog.model';
import { CatalogCategory } from './catalogue.service';
import { BookDetailReservationGroupModel } from '../views/models/BookDetailReservationGroup.model';
import { MenuItemBulletListModel } from '../views/models/menu-item-bullet-list.model';
import { ItemService } from './item.service';
import { environment } from '../../environments/environment';

export class TimeTableReservation {
  book: MenuItemBookModel;
  detail: MenuItemBookDetailModel[];

  constructor(book = new MenuItemBookModel(),
    detail = []) {
    this.book = book;
    this.detail = detail;
  }
}

@Injectable({
  providedIn: 'root'
})
export class TimetableAndReservationService {
  record_change$ = new BehaviorSubject<TimeTableReservation[]>([]);
  datas: TimeTableReservation[] = [];

  constructor(private httpClient: HttpClient,
    private itemService: ItemService) {
  }

  getData(itemID: number) {
    return new Promise((resolve) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/item_book/' + itemID).subscribe(
        (data: MenuItemBookModel[]) => {
          this.datas = [];
          if (data.length == 0) {
            this.record_change$.next(this.datas);
          }

          data.forEach((x, i) => {
            const Timedata = new TimeTableReservation();
            this.httpClient.get(environment.baseURL + '/v2/api' + '/item_book_detail/' + x.id).subscribe(
              async (detaildatas: MenuItemBookDetailModel[]) => {
                Timedata.book = x;
                Timedata.detail = detaildatas || [];

                if (!Timedata.detail || Timedata.detail.length === 0) {
                  const scheduleLine = new MenuItemBookDetailModel();
                  scheduleLine.menu_item_book_id = Timedata.book.id;
                  scheduleLine.start_time = new Date();
                  scheduleLine.end_time = new Date();
                  scheduleLine.menu_item_id = Timedata.book.menu_item_id;
                  scheduleLine.currency_code = '';
                  await this.postItemDetailData(scheduleLine);
                  this.getData(itemID);
                  resolve(null);
                }

                this.datas.push(Timedata);

                this.datas.forEach(book => {

                  if (book.detail) {
                    book.detail.map(detail => {
                      try {
                        detail.start_time = new Date(detail.start_time || new Date()).toISOString().split('T')[1].slice(0, 5);
                        detail.end_time = new Date(detail.end_time || new Date()).toISOString().split('T')[1].slice(0, 5);
                      } catch { }
                    });
                  }

                  const map = new Map(this.datas.map(x => [x.book.id, x]));
                  const unique = [...map.values()];

                })

                this.datas = this.datas.sort((x, y) => x.book.id - y.book.id)

                this.record_change$.next(this.datas);
                resolve(true);

              });
          });

        })
    });
  }

  postItemData(data: MenuItemModel, id) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/menu_item', data).subscribe(
      () => {
      },
      error => console.log(error),
      () => this.getData(data.id)
    );
  }

  addItemBookDatas(schedule: MenuItemBookModel): Promise<MenuItemBookModel> {
    return new Promise((resolve) => {
      const datas = this.record_change$.getValue();
      this.httpClient.post(environment.baseURL + '/v2/api' + '/item_book', schedule).subscribe(
        (data: MenuItemBookModel) => {
          resolve(data);
        },
        (err) => console.log(err),
        () => {
          // const time: TimeTableReservation = new TimeTableReservation();
          // time.book = schedule;
          // datas.push(time);
          // this.datas.forEach(x => {
          //   if (x.detail.length == 0) {
          //     // const detail: MenuItemBookDetailModel = new MenuItemBookDetailModel();
          //     // detail.menu_item_id = schedule.menu_item_id;
          //     // detail.menu_item_book_id = this.datas[0].book.id;
          //     // this.postItemDetailData(detail);
          //   }
          // });
          // this.record_change$.next(datas);
        }
      );
    })
  }

  putItemBookData(schedule: MenuItemBookModel) {
    schedule.bookable_in_advance_days = +schedule.bookable_in_advance_days;
    schedule.minimum_time_in_advance_minute = +schedule.minimum_time_in_advance_minute;
    const datas = this.record_change$.getValue();
    console.log(schedule);
    this.httpClient.put(environment.baseURL + '/v2/api' + '/item_book/' + schedule.id, schedule).subscribe(
      () => {
      },
      (err) => console.log(err),
      () => {
        this.record_change$.next(datas);
      }
    );
  }

  deleteItemBookData(id: number) {
    return new Promise((resolve) => {
      this.httpClient.delete(environment.baseURL + '/v2/api' + '/item_book/' + id).subscribe(
        (data) => {
          console.log(data);
          resolve(true);
        }
      );
    })
  }

  postItemDetailData(schedules: MenuItemBookDetailModel) {
    return new Promise((resolve) => {
      schedules.start_time = new Date(schedules.start_time);
      schedules.end_time = new Date(schedules.end_time);
      this.httpClient.post(environment.baseURL + '/v2/api' + '/item_book_detail', schedules).subscribe(
        () => {
          resolve(true);
        },
        (err) => console.log(err),
        () => { }
      );
    })
  }

  putItemDetailData(schedules: MenuItemBookDetailModel) {
    return new Promise((resolve) => {
      schedules.start_time = new Date(schedules.start_time);
      schedules.end_time = new Date(schedules.end_time);
      schedules.interval = +schedules.interval;
      schedules.price = +schedules.price;
      schedules.offer_price = +schedules.offer_price;
      schedules.limit = +schedules.limit;
      schedules.child_price = +schedules.child_price;
      this.httpClient.put(environment.baseURL + '/v2/api' + '/item_book_detail/' + schedules.id, schedules).subscribe(
        () => {
          resolve(true);
        },
        (err) => console.log(err)
      );
    })
  }

  deleteItemDetailData(i: number, j: number) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/item_book_detail/' + this.datas[i].detail[j].id).subscribe(
      () => {
      },
      (err) => console.log(err),
      () => {
        this.datas[i].detail.splice(j, 1);
        this.record_change$.next(this.datas);
      }
    );
  }

  putReservationGroupData(data: BookDetailReservationGroupModel) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/item_book_detail_res_group/' + data.id, data).subscribe(
      () => {
      },
      (error) => {
        console.log(error);
      },
      () => {
        this.getData(this.itemService.record_change$.getValue().id);
      });
  }

  deleteReservationGroupData(id: number) {
    this.httpClient.delete(environment.baseURL + '/v2/api' + '/item_book_detail_res_group/' + id).subscribe(
      () => this.getData(this.itemService.record_change$.getValue().id)
    );
  }

  postReservationGroupData(data: BookDetailReservationGroupModel) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/item_book_detail_res_group', data).subscribe(
      () => {
      },
      error => console.log(error),
      () => {
        this.getData(this.itemService.record_change$.getValue().id);
      }
    );
  }

}

